import { c as _c } from "react/compiler-runtime";
import { cva } from 'class-variance-authority';
import Link from 'next/link';
import { memo } from 'react';
type SubLinkProps = {
  href: string;
  text: string;
  isActive: boolean;
  suffixElement?: React.ReactNode;
};
const subLinkStyles = cva('no-underline ml-6 h-8 md:h-7 pl-1.5 pr-1 rounded-default flex items-center justify-between gap-1 relative overflow-hidden transition-[color,background-color,transform] duration-fast ease-out active:scale-pressed motion-reduce:active:scale-100', {
  variants: {
    isActive: {
      true: 'text-primary text-label-3 bg-senary/70',
      false: 'text-tertiary text-body-3 hover:text-primary hover:bg-hover'
    }
  }
});
const SubLink = t0 => {
  const $ = _c(9);
  const {
    href,
    text,
    isActive,
    suffixElement
  } = t0;
  let t1;
  if ($[0] !== isActive) {
    t1 = subLinkStyles({
      isActive
    });
    $[0] = isActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== text) {
    t2 = <span className="truncate">{text}</span>;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== href || $[5] !== suffixElement || $[6] !== t1 || $[7] !== t2) {
    t3 = <Link href={href} className={t1}>{t2}{suffixElement}</Link>;
    $[4] = href;
    $[5] = suffixElement;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default memo(SubLink);